/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react'
import {
    Create,
    Edit,
    required,
    SimpleForm,
    TextInput,
    useNotify,
    useRefresh,
    useRedirect,
    useDataProvider,
} from 'react-admin'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import BackButton from '../../components/BackButton'

import CountryList from '../Country/CountryList'
import SearchReferenceInput from '../../components/QuickSearch/QuickSearch'
import Title from '../../components/Title/Title'
import CustomValidater from '../../components/Utility/Validater'

const ProvinceComponent = (props) => {
    const user = useSelector((state) => state.auth)
    const userData = {
        created_by: user.description,
        modified_by: user.description,
    }
    const { title, isEdit, record } = props

    return (
        <SimpleForm
            validate={(values) => CustomValidater(values, props)}
            style={{ width: '100%' }}
            {...{ ...props, record: { ...record, ...userData } }}
            variant="outlined"
            warnWhenUnsavedChanges
            initialValues={userData}
        >
            <Title title={title} />
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Code"
                    source="code"
                    validate={[required()]}
                    disabled={isEdit}
                />
            </div>
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Description"
                    source="description"
                    validate={required()}
                />
            </div>
            <div className="container">
                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                    }}
                >
                    <SearchReferenceInput
                        {...props}
                        source="country_id"
                        reference="Country"
                        allowEmpty
                        validate={required()}
                        perPage={10000}
                        list={CountryList}
                        resource="PY_CountryTAB"
                        basePath="/PY_CountryTAB"
                    />
                </div>
            </div>
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Created By"
                    source="created_by"
                    validate={required()}
                />
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Modified By"
                    source="modified_by"
                    validate={required()}
                />
            </div>
        </SimpleForm>
    )
}

export default function CreateProvince(props) {
    const [country, setCountry] = useState([])
    const notify = useNotify()
    const refresh = useRefresh()
    const redirect = useRedirect()
    const onSuccess = () => {
        notify(`Changes saved`, { type: 'success' })
        redirect('/PY_ProvinceTAB')
        refresh()
    }
    const { isEdit } = props
    const dataProvider = useDataProvider()
    useEffect(() => {
        dataProvider
            .getList('PY_CountryTAB', {})
            .then(({ data }) => {
                console.log('data', data)
                setCountry(data)
            })
            .catch((error) => {
                console.log('errr', error)
            })
    }, [])
    if (isEdit)
        return (
            <>
                <BackButton path="/PY_ProvinceTAB" />
                <Edit {...props} undoable={false}>
                    <ProvinceComponent
                        title="Edit Province"
                        country={country}
                        isEdit
                    />
                </Edit>
            </>
        )
    return (
        <>
            <BackButton path="/PY_ProvinceTAB" />
            <Create onSuccess={onSuccess} {...props}>
                <ProvinceComponent
                    title="Create Province"
                    country={country}
                    isEdit={false}
                />
            </Create>
        </>
    )
}

CreateProvince.propTypes = {
    isEdit: PropTypes.bool.isRequired,
}

ProvinceComponent.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    record: PropTypes.objectOf(PropTypes.any).isRequired,
}
